import { useContext, useEffect, useMemo } from 'react';
import useResizeListener from '../../../hooks/useResizeListener';
import mediaQuery from '../../../helpers/mediaQuery';
import { ListerContext } from '../listerContext';
import { ListerActionTypes } from '../listerReducer';
import { simpleBodyScrollLock } from '../../../helpers/bodyScrollLock';

export default function useModal(): void {
  const [{ isFacetsModalDisplayed }, dispatch] = useContext(ListerContext);
  const { innerWidth } = useResizeListener();
  const isLargeUp = useMemo(() => mediaQuery.rolexGlobal.isLargeUp(), [innerWidth]);

  useEffect(() => {
    dispatch({
      type: ListerActionTypes.SET_IS_FACETS_MODAL_DISPLAYED,
      isFacetsModalDisplayed: isLargeUp ? false : isFacetsModalDisplayed
    });
    simpleBodyScrollLock(!isLargeUp && isFacetsModalDisplayed);
  }, [isLargeUp, isFacetsModalDisplayed]);
}
